import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import NotificationsBell from "../components/NotificationsBell";
import OfflineBadge from "../components/OfflineBadge";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
    const { user } = useAuth();
    return (
        <div className="min-h-screen bg-onego-bg flex" data-testid="dashboard-shell">
            <Sidebar />
            <div className="flex-1 min-w-0">
                <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-slate-200">
                    <div className="px-6 lg:px-10 py-4 flex items-center justify-between gap-3">
                        <div>
                            <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Merchant dashboard</p>
                            <p className="font-display text-lg font-bold text-onego-navy" data-testid="dashboard-business-name">
                                {user?.business_name || user?.name}
                            </p>
                        </div>
                        <div className="flex items-center gap-2">
                            <OfflineBadge />
                            <span className="og-chip hidden md:inline-flex">{user?.country}</span>
                            {user?.subscription && (
                                <span className="og-chip og-gradient text-white capitalize" data-testid="header-plan-chip">
                                    {user.subscription}
                                </span>
                            )}
                            <LanguageSwitcher />
                            <NotificationsBell userId={user?.id} />
                            <div className="h-10 w-10 rounded-full og-gradient flex items-center justify-center text-white font-bold">
                                {user?.name?.[0]?.toUpperCase() || "M"}
                            </div>
                        </div>
                    </div>
                </header>
                <main className="px-6 lg:px-10 py-8">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
